import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import IconCollection from '../../../IconCollection/IconCollection';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { SUBMIT_PLAYERS_AND_MATCH_DATA } from '../../../redux/actionTypes/actionTypes';
import { submitPlayersAndMatchData } from '../../../redux/reducers/playersReducer';
const PlayersMinuteLogs = () => {
  const matchData = useSelector((state) => state?.playersReducer?.matchData);
  const { event_id, event_team_a_id, event_team_b_id, event_group_id } = matchData
  const teamOneName = matchData?.team_a_name;
  const teamTwoName = matchData?.team_b_name;
  const team_a_rosters = matchData?.team_a_rosters

  const team_b_rosters = matchData?.team_b_rosters
  const [team, setTeam] = useState('team1')

  const [editModalOpen, setEditModelOpen] = useState(null)
  const [editModalOpenTeam2, setEditModelOpenTeam2] = useState(null)
  const [editMinuteLoading, setEditLoading] = useState(false)
  const [editMinuteLoading2, setEditLoading2] = useState(false)
  const [editSecond, setEditSecond] = useState()
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();


  const token = window.localStorage.getItem("token");
  const dispatch = useDispatch()
  const handleEditModalOpen = (value) => {
    setEditModelOpen(value)
  }
  const handleEditModalOpen2 = (value) => {
    setEditModelOpenTeam2(value)
  }

  const onSubmitTeamOne = async (data) => {

    const play_sec = Number(data.minute) * 60 + Number(data.second)
    setEditLoading(true)
    const playerData = [
      {
        "r_id": editModalOpen.roster_id,
        "t_id": event_team_a_id,
        "event_id": event_id,
        "eg_id": event_group_id,
        "present": editModalOpen.is_present,
        "startinglinup": editModalOpen.is_startinglinup,
        "play_sec": play_sec,
      }]

    const formdata = new FormData();
    formdata.append("data", JSON.stringify([
      ...playerData
    ]));

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_ROOT}` + "/api/playerStatus/", formdata,
        {
          headers: {
            "Authorization": `${token}`,
          },
        }
      );

      if (response.status == 200) {
        setEditLoading(!true)
        setEditModelOpen(null)
        // dispatch(
        //   {
        //     type: SUBMIT_PLAYERS_AND_MATCH_DATA,
        //     payload: response.data.data,
        //   }
        // );
        dispatch(submitPlayersAndMatchData(response.data.data))




      }
    } catch (error) {
      console.error("Error submitting team one data:", error);
    }
  }
  const onSubmitTeamTwo = async (data) => {

    setEditLoading2(true)
    const play_sec = Number(data.minute2) * 60 + Number(data.second2)
    const playerData = [
      {
        "r_id": editModalOpenTeam2.roster_id,
        "t_id": event_team_b_id,
        "event_id": event_id,
        "eg_id": event_group_id,
        "present": editModalOpenTeam2.is_present,
        "startinglinup": editModalOpenTeam2.is_startinglinup,
        "play_sec": play_sec,
      }]

    const formdata = new FormData();
    formdata.append("data", JSON.stringify([
      ...playerData
    ]));

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_ROOT}` + "/api/playerStatus/", formdata,
        {
          headers: {
            "Authorization": `${token}`,
          },
        }
      );

      if (response.status == 200) {
        setEditLoading2(!true)
        setEditModelOpenTeam2(null)
        // dispatch(
        //   {
        //     type: SUBMIT_PLAYERS_AND_MATCH_DATA,
        //     payload: response.data.data,
        //   }
        // );
        dispatch(submitPlayersAndMatchData(response.data.data))



      }
    } catch (error) {
      console.error("Error submitting team one data:", error);
    }
  }


  function formatTimeFromSeconds(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const formattedTime = `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    return formattedTime;
  }

  function onlyMinutes(totalSeconds) {
    const minutes = Math.floor(totalSeconds / 60); // Calculate minutes
    return minutes; // Return the calculated minutes
  }
  function onlySeconds(totalSeconds) {
    const seconds = totalSeconds % 60; // Calculate remaining seconds after converting to minutes
    return seconds; // Return the remaining seconds
  }

  return (
    <div>
      <div className='flex  items-center justify-evenly mt-4'>
        <div onClick={() => [setTeam('team1'),]} className={`text-2xl cursor-pointer font-bebas ${team == 'team1' ? 'text-[#B48658]' : 'text-black'}`}>{teamOneName}</div>
        <div onClick={() => [setTeam('team2'),]} className={`text-2xl cursor-pointer font-bebas ${team == 'team2' ? 'text-[#B48658]' : 'text-black'}`}>{teamTwoName}</div>
      </div>
      <div className='w-full h-[1px] bg-[#E8E8E8]'></div>

      <div>
        {
          team == 'team1' &&
          <div className='w-full my-4'>
            <div className='flex justify-center items-center border-[1px] border-[#E8E8E8]'>
              <div className='w-[45%] py-3  flex justify-center items-center font-montserrat text-xl capitalize'>jersey number</div>
              <div className='w-[45%] py-3 border-l-[1px] border-[#E8E8E8] flex justify-center items-center font-montserrat text-xl capitalize'>PlayIng Time</div>
              <div className='w-[10%]'></div>
            </div>
            {
              team_a_rosters && [...team_a_rosters].sort((a, b) => a.jersey_number - b.jersey_number).map((player) => (
                <div className='flex justify-center items-center border-[1px] border-t-0 border-[#E8E8E8]'>
                  <div className='w-[45%] py-3  flex justify-center items-center font-montserrat text-xl capitalize'>{player?.jersey_number}</div>
                  <div className='w-[45%] py-3 border-l-[1px] border-[#E8E8E8] flex justify-center items-center font-montserrat text-xl capitalize'>{formatTimeFromSeconds(player?.play_sec)}</div>
                  <button
                    onClick={() => handleEditModalOpen(player)}
                    className='w-[10%]'>
                    <IconCollection
                      name="edit-box-line"
                      customClass='md:max-w-[24px] max-w-[10.16px] w-full md:h-[24px] h-[10.16px]'
                    />
                  </button>
                </div>
              ))
            }

          </div>
        }
      </div>
      <div>
        {
          team == 'team2' &&
          <div className='w-full my-4'>
            <div className='flex justify-center items-center border-[1px] border-[#E8E8E8]'>
              <div className='w-[45%] py-3  flex justify-center items-center font-montserrat text-xl capitalize'>jersey number</div>
              <div className='w-[45%] py-3 border-l-[1px] border-[#E8E8E8] flex justify-center items-center font-montserrat text-xl capitalize'>PlayIng Time</div>
              <div className='w-[10%]'></div>
            </div>
            {
              team_b_rosters && [...team_b_rosters].sort((a, b) => a.jersey_number - b.jersey_number).map((player) => (
                <div className='flex justify-center items-center border-[1px] border-t-0 border-[#E8E8E8]'>
                  <div className='w-[45%] py-3  flex justify-center items-center font-montserrat text-xl capitalize'>{player?.jersey_number}</div>
                  <div className='w-[45%] py-3 border-l-[1px] border-[#E8E8E8] flex justify-center items-center font-montserrat text-xl capitalize'>{formatTimeFromSeconds(player?.play_sec)}</div>
                  <button
                    onClick={() => handleEditModalOpen2(player)}
                    className='w-[10%]'>
                    <IconCollection
                      name="edit-box-line"
                      customClass='md:max-w-[24px] max-w-[10.16px] w-full md:h-[24px] h-[10.16px]'
                    />
                  </button>
                </div>
              ))
            }

          </div>
        }
      </div>
      {
        editModalOpen && <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 '>
          <form onSubmit={handleSubmit(onSubmitTeamOne)} className='max-w-[300px] w-full h-auto min-h-44 bg-white p-10 rounded-md'>
            <p className='text-center py-2 font-bebas text-2xl'>Player Playing time Edit</p>

            <div className=' flex justify-between items-center mt-5'>
              <input className='max-w-[100px] h-12 font-bebas text-2xl rounded-md bg-slate-100 outline-none p-3'
                type="text"
                defaultValue={onlyMinutes(editModalOpen?.play_sec)}
                {...register("minute", {
                  pattern: {
                    value: /^[0-9]*$/,
                    message: "Numbers Allowed",
                  },
                })}
              />

              <input className='max-w-[100px] h-12 font-bebas text-2xl rounded-md bg-slate-100 outline-none p-3'
                type="text"
                defaultValue={onlySeconds(editModalOpen?.play_sec)}

                {...register("second", {
                  pattern: {
                    value: /^[0-9]*$/,
                    message: "Numbers Allowed",
                  },
                })}
              />
            </div>
            <div>
              <div className='mb-6 flex'>
                <p>
                  {errors.minute?.type == "pattern" && (
                    <span className="label-text-alt text-red-600 text-xs pl-2">
                      {errors?.minute?.message}
                    </span>
                  )}
                </p>
                <p>
                  {errors.second?.type == "pattern" && (
                    <span className="label-text-alt text-red-600 text-xs pl-2">
                      {errors?.second?.message}
                    </span>
                  )}
                </p>
              </div>
            </div>
            <div className='flex justify-center items-center gap-5'>
              <button
                disabled={editMinuteLoading}
                className='max-w-[100px] rounded h-[30px] w-full bg-black   font-bebas text-lg text-white '
                onClick={() => setEditModelOpen(null)}
              >close</button>
              <button
                type='submit'
                disabled={editMinuteLoading}
                className='max-w-[100px] rounded h-[30px] w-full bg-primary font-bebas text-lg text-white'>{editMinuteLoading ? "Saving" : "Save"}</button>
            </div>

          </form>

        </div>
      }
      {
        editModalOpenTeam2 && <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 '>
          <form onSubmit={handleSubmit(onSubmitTeamTwo)} className='max-w-[300px] w-full h-auto min-h-44 bg-white p-10 rounded-md'>
            <p className='text-center py-2 font-bebas text-2xl'>Player Playing time Edit</p>

            <div className=' flex justify-between items-center mt-5'>
              <input className='max-w-[100px] h-12 font-bebas text-2xl rounded-md bg-slate-100 outline-none p-3'
                type="text"
                defaultValue={onlyMinutes(editModalOpenTeam2?.play_sec)}
                {...register("minute2", {
                  pattern: {
                    value: /^[0-9]*$/,
                    message: "Numbers Allowed",
                  },
                })}
              />

              <input className='max-w-[100px] h-12 font-bebas text-2xl rounded-md bg-slate-100 outline-none p-3'
                type="text"
                defaultValue={onlySeconds(editModalOpenTeam2?.play_sec)}

                {...register("second2", {
                  pattern: {
                    value: /^[0-9]*$/,
                    message: "Numbers Allowed",
                  },
                })}
              />
            </div>
            <div>
              <div className='mb-6 flex'>
                <p>
                  {errors.minute?.type == "pattern" && (
                    <span className="label-text-alt text-red-600 text-xs pl-2">
                      {errors?.minute?.message}
                    </span>
                  )}
                </p>
                <p>
                  {errors.second?.type == "pattern" && (
                    <span className="label-text-alt text-red-600 text-xs pl-2">
                      {errors?.second?.message}
                    </span>
                  )}
                </p>
              </div>
            </div>
            <div className='flex justify-center items-center gap-5'>
              <button disabled={editMinuteLoading2} className='max-w-[100px] rounded h-[30px] w-full bg-black   font-bebas text-lg text-white '
                onClick={() => setEditModelOpenTeam2(null)}
              >close</button>
              <button disabled={editMinuteLoading2} type='submit' className='max-w-[100px] rounded h-[30px] w-full bg-primary font-bebas text-lg text-white'>{editMinuteLoading2 ? "Saving" : "Save"}</button>
            </div>

          </form>

        </div>
      }

    </div>
  );
};

export default PlayersMinuteLogs;